import {
  HOLIDAY_ALL,
  HOLIDAY_GET,
  HOLIDAY_DEL,
  HOLIDAY_PUT,
  HOLIDAY_POST,
  HOLIDAY_LOADING,
  HOLIDAY_ERROR,
} from '../../actions/types';

const initialState = {
  holiday: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case HOLIDAY_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case HOLIDAY_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case HOLIDAY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case HOLIDAY_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case HOLIDAY_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case HOLIDAY_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case HOLIDAY_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    default:
      return state;
  }
}
